import { render, staticRenderFns } from "./SchemaSearchConfig.vue?vue&type=template&id=f79233c8"
import script from "./SchemaSearchConfig.vue?vue&type=script&lang=js"
export * from "./SchemaSearchConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports